// @flow
import * as React from 'react';
import UserActions from 'user/UserActions';
import EventTracking from 'lib/EventTracking';
import ConfirmDialog from 'components/ConfirmDialog';

type Props = {
  title: string,
  subtext: string,
  reason?: ?string,
  onDeleted: Function,
  sourceEventKey: string,
  onRequestHide?: Function,
};

class DeleteAccountConfirmationDialog extends React.Component<Props, void> {
  componentDidMount() {
    EventTracking.trackKey(this.key('view'));
  }

  key = (suffix: string) => {
    return `account_settings.delete_account_modal.${this.props.sourceEventKey}.${suffix}`;
  };

  handleConfirmation = () => {
    return UserActions.delete(undefined, this.props.reason);
  };

  render() {
    return (
      <ConfirmDialog
        size="xsmall"
        glyphColor="lava"
        title={this.props.title}
        cancelButtonText="Cancel"
        actionButtonText="Delete"
        subtext={this.props.subtext}
        onConfirm={this.props.onDeleted}
        onRequestHide={this.props.onRequestHide}
        cancelEventKey={this.key('cancel.click')}
        preConfirmPromise={this.handleConfirmation}
        confirmEventKey={this.key('delete_account.click')}
      />
    );
  }
}

export default DeleteAccountConfirmationDialog;
